import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

import { useDeleteLocation } from "../hooks/useDeleteLocation";

export const DeleteLocationModal = ({ isOpen, onClose, location, onSuccess }) => {
  const deleteMutation = useDeleteLocation();

  const handleDelete = () => {
    deleteMutation.mutate(location?.id, {
      onSuccess: () => {
        onSuccess?.();
        onClose();
      },
    });
  };

  if (!location) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} title="Delete Location" width={480}>
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <p style={{ fontSize: "16px", color: "#26252c", margin: 0 }}>
          Are you sure you want to remove <strong>{location.name}</strong>?
          Existing appointments already booked there keep showing this
          location; it just won't be offered for new bookings.
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <Button variant="outline" size="large" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={handleDelete}
            disabled={deleteMutation.isPending}
          >
            {deleteMutation.isPending ? "Removing..." : "Remove"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
